import React from 'react';

import ThirdPartyStepHeader from './ThirdPartyStepHeader';
import {ThirdPartyStepViewProps} from './Types';

/**
 * The Third-Party Step main view, which renders a `WAITING` or `SUCCEEDED` header
 *
 * This component proxies to `ThirdPartyStepHeader`, so that `ThirdPartyStepHeader` can be reused for other
 * callers like the File Dashboard View.
 */
export default function ThirdPartyStepView(props: ThirdPartyStepViewProps): JSX.Element {
  return (
    <ThirdPartyStepHeader analysis={props.analysis} clientStateId={props.clientStateId} step={props.step} />
  );
}
